import React, { useContext, useState, useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import neatSocket from '@theneatcompany/neatsocket-client'

import { ENV } from '@/config'
import { sendError } from '@/utils/rollbar'
import { useAccounts } from '@/components/Providers/AccountsProvider'
import { getJWTFromStorage } from '@/utils/tokens'

const NeatSocketContext = React.createContext({})

export const withNeatSocket = (Comp) => (props) => (
  <NeatSocketContext.Consumer>
    {(providerProps) => <Comp {...props} neatSocket={providerProps} />}
  </NeatSocketContext.Consumer>
)

export const useNeatSocket = () => useContext(NeatSocketContext)

const NeatSocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null)
  const [isConnected, setConnected] = useState(false)
  const { isLoading, hasError } = useAccounts()

  const initialize = async () => {
    try {
      const result = await neatSocket.connect({
        JWT: `Bearer ${getJWTFromStorage()}`,
        debug: false,
        env: ENV,
      })
      setSocket(result)
      setConnected(true)
    } catch (e) {
      sendError(e, 'Error connecting to Neat Socket Client.')
    }
  }

  useEffect(() => {
    if (!socket && !isLoading && !hasError) initialize()
  }, [socket, isLoading, hasError])

  const providerValue = useMemo(
    () => ({
      isConnected,
      socket,
    }),
    [isConnected, socket],
  )

  return (
    <NeatSocketContext.Provider value={providerValue}>
      {children}
    </NeatSocketContext.Provider>
  )
}

NeatSocketProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export default NeatSocketProvider
